module.exports = __webpack_public_path__ + "img/pngegg.5bd86de0.png";